import { Link } from '@mui/material';
import { Fields } from 'common/form';
import Yup from 'utils/validation';

const buildSchema = (requireEngaged: boolean) =>
  Yup.object({
    relevant: Yup.boolean().test(
      'confirm',
      'You must agree with all statements.',
      function (value) {
        if (value !== true || this.parent.guidelines !== true) return false;
        if (requireEngaged && this.parent.engaged !== true) return false;
        return true;
      }
    ),
    engaged: Yup.boolean(),
    guidelines: Yup.boolean()
  });

type WhatsAppConfirmation = Yup.InferType<ReturnType<typeof buildSchema>>;

const relevantField: Fields<WhatsAppConfirmation>['relevant'] = {
  group: 'confirm',
  type: 'checkbox',
  checkboxLabel: 'My campaign is relevant and specific to its recipients',
  controlSx: {
    color: 'customGrey.dark'
  }
};

const engagedField: Fields<WhatsAppConfirmation>['engaged'] = {
  group: 'confirm',
  type: 'checkbox',
  checkboxLabel:
    'I am only contacting engaged, opted-in candidates i.e. not for cold outreach'
};

const guidelinesField: Fields<WhatsAppConfirmation>['guidelines'] = {
  group: 'confirm',
  type: 'checkbox',
  checkboxLabel: (
    <>
      I have read and understood WhatsApp's{' '}
      <Link
        href="https://www.whatsapp.com/legal/messaging-guidelines"
        target="_blank"
      >
        messaging guidelines
      </Link>
    </>
  )
};

export const getWhatsAppConfirmForm = (allowColdOutreach: boolean) => {
  const fields: Fields<WhatsAppConfirmation> = allowColdOutreach
    ? ({
        relevant: relevantField,
        guidelines: guidelinesField
      } as Fields<WhatsAppConfirmation>)
    : {
        relevant: relevantField,
        engaged: engagedField,
        guidelines: guidelinesField
      };

  return {
    schema: buildSchema(!allowColdOutreach),
    fields,
    groups: {
      confirm: {
        label: 'Confirm:'
      }
    }
  };
};
